
import UserFetch from '../fetch/user';
import SchoolFetch from '../fetch/school';
const userWebService =  new UserFetch()
const schoolWebService =  new SchoolFetch()
export  {
  userWebService,
  schoolWebService,
};



// WEBPACK FOOTER //
// ./src/utils/webService.js